import { defineStore } from 'pinia';

interface Dog {
  microchipId: string,
  geneticId: string,
  animalName: string,
  animalGender: string,
  animalKind: string
}

export const useDogStore = defineStore('dog', {
  state: (): Dog => ({
    microchipId: "",
    geneticId: "",
    animalName: "",
    animalGender: "",
    animalKind: "",
  }),
  getters: {
    animalNameSuffix(this: any): string {
      const suffix: string = this.isMale() ? "くん" : "ちゃん"
      return this.animalName + suffix
    }
  },
  actions: {
    isMale() {
      return this.animalGender == "オス" ? true : false
    },
    hasGeneticId() {
      return !(this.geneticId === "" || this.geneticId === "未採取") ? true : false
    }
  }
});
